import classNames from 'classnames';
import { CSSProperties } from 'react';

import SafeLinkWithGaEvent, {
    SafeLinkWithGaEventProps
} from '@tb-core/components/composites/safe-link-with-ga-event';
import ThemedColor, { ColorTheme } from '@tb-core/components/themed/color';

import styles from './styles.scss';

export interface ThemableLinkButtonProps extends SafeLinkWithGaEventProps {
    border?: boolean;
    colorTheme?: CSSProperties;
    inverse?: boolean;
}

// This component will render the same look as a primary button
const ThemableLinkButton = ({
    border = true,
    className,
    colorTheme,
    inverse = false,
    theme,
    ...props
}: ThemableLinkButtonProps & { theme?: ColorTheme }) => (
    <ThemedColor theme={theme}>
        {({ bgColor, color }) => (
            <SafeLinkWithGaEvent
                {...props}
                className={classNames(
                    styles['link-button'],
                    {
                        [styles['no-border']]: !border,
                        [styles.inverse]: inverse,
                        [bgColor]: !inverse,
                        [color]: inverse
                    },
                    className
                )}
                style={colorTheme}
            />
        )}
    </ThemedColor>
);

export default ThemableLinkButton;
